import toastr from 'toastr'

toastr.options.positionClass = 'toast-bottom-right'

class Toast {
  success (message, title = '') {
    toastr.success(message, title)
  }

  error (message, title = 'Errore') {
    toastr.error(message, title)
  }

  warning (message, title = 'Info') {
    toastr.warning(message, title)
  }
}

export default new Toast()
